module.exports = __webpack_public_path__ + "static/media/Oxygen-Bold.d37ff162.otf";